// extracted by mini-css-extract-plugin
export default {"InputAlignmentContainer":"eRZ92CkC","alignment-spacer":"NUDbWjjN"};